import { Injectable } from '@angular/core';
import { BaseStorageService } from './BaseStorageService';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService extends BaseStorageService {
  protected override readonly storage = localStorage;
}
